module.exports = __webpack_public_path__ + "img/blog-header.cb0ce19a.jpg";